module.exports = __webpack_public_path__ + "img/avocadolachskugelartshotfrontal.5c575552.jpg";